<main class="collaborators-page">

  <!-- HERO (offset top per non finire sotto la nav) -->
  <section class="collab-hero">
    <div class="container-xl">
      <div class="collab-hero-card card-sami">
        <h1 class="collab-title">I nostri migliori collaboratori</h1>

        <p class="collab-subtitle">
          Collaboriamo con realtà selezionate sul territorio per offrire servizi affidabili, puntuali e di qualità.
          In questa pagina trovi i partner principali: puoi visitare i loro siti cliccando sui loghi.
        </p>
      </div>
    </div>
  </section>

  <!-- LOGHI (SCROLL + SCROLLBAR) -->
  <section id="loghi" class="collab-section section-soft">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="section-title">Partner & Collaborazioni</h2>
        <p class="section-subtitle">
          Scorri per vedere tutti i partner. I loghi sono cliccabili e portano ai siti ufficiali.
        </p>
      </div>

      <div class="logos-shell card-sami">
        <ul class="logos-track" aria-label="Loghi collaboratori">
          <li class="logos-item" *ngFor="let p of partners; trackBy: trackByPartnerName">
            <a
              class="logos-link"
              [href]="p.url"
              target="_blank"
              rel="noopener sponsored"
              [attr.aria-label]="'Visita il sito di ' + p.name"
              [title]="p.name"
            >
              <img
                class="logos-img"
                [src]="p.logo"
                [alt]="'Logo ' + p.name"
                width="260"
                height="150"
                loading="lazy"
                decoding="async"
              />
            </a>
          </li>
        </ul>

        <div class="logos-hint">
          <span class="small text-muted">
            Suggerimento: scorri orizzontalmente (touch/trackpad) oppure usa la barra.
          </span>
        </div>
      </div>
    </div>
  </section>

  <!-- DETTAGLIO PARTNER (LOGO SX + TESTO DX) -->
  <section id="dettagli" class="collab-section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="section-title">Approfondimento collaboratori</h2>
        <p class="section-subtitle">
          Una panoramica rapida e ordinata dei partner con cui collaboriamo.
          Ogni scheda contiene una breve descrizione e il link al sito ufficiale.
        </p>
      </div>

      <div class="partners-grid" aria-label="Elenco collaboratori">
        <article class="partner-card card-sami" *ngFor="let p of partners; trackBy: trackByPartnerName">
          <a
            class="partner-logo"
            [href]="p.url"
            target="_blank"
            rel="noopener sponsored"
            [title]="p.name"
            [attr.aria-label]="'Apri il sito di ' + p.name"
          >
            <img
              [src]="p.logo"
              [alt]="'Logo ' + p.name"
              width="320"
              height="190"
              loading="lazy"
              decoding="async"
            />
          </a>

          <div class="partner-body">
            <h3 class="partner-name">{{ p.name }}</h3>
            <p class="partner-desc">{{ p.description }}</p>

            <div class="partner-actions">
              <a class="btn-sami-outline btn-sm" [href]="p.url" target="_blank" rel="noopener sponsored">
                Visita il sito
              </a>
            </div>
          </div>
        </article>
      </div>

    </div>
  </section>

</main>
